// Login.js
import React, { useState } from "react";
import { signInWithPopup, signOut } from "firebase/auth";
import {
  auth,
  googleProvider,
  facebookProvider,
  appleProvider,
} from "../firebase";

function Login({ user, onAuthChange }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = async (provider) => {
    setLoading(true);
    setError(null);
    try {
      const result = await signInWithPopup(auth, provider);
      onAuthChange(result.user);
    } catch (error) {
      console.error("Authentication error:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      onAuthChange(null);
    } catch (error) {
      console.error("Sign out error:", error);
      setError(error.message);
    }
  };

  if (user) {
    return (
      <div className="login-container">
        <div className="user-info">
          {user.photoURL ? (
            <img
              src={user.photoURL}
              alt={user.displayName}
              className="user-avatar"
            />
          ) : (
            <div className="user-avatar-placeholder">
              {user.displayName
                ? user.displayName.charAt(0).toUpperCase()
                : "?"}
            </div>
          )}
          <span>Welcome, {user.displayName || "User"}</span>
        </div>
        <button onClick={handleSignOut} className="sign-out-btn">
          Sign Out
        </button>
      </div>
    );
  }

  return (
    <div className="login-container">
      <h2>Sign In</h2>
      {error && <div className="error-message">{error}</div>}
      <div className="auth-buttons">
        <button
          onClick={() => handleSignIn(googleProvider)}
          disabled={loading}
          className="auth-btn google-btn"
        >
          {loading ? "Signing in..." : "Sign in with Google"}
        </button>
        <button
          onClick={() => handleSignIn(facebookProvider)}
          disabled={loading}
          className="auth-btn facebook-btn"
        >
          {loading ? "Signing in..." : "Sign in with Facebook"}
        </button>
        <button
          onClick={() => handleSignIn(appleProvider)}
          disabled={loading}
          className="auth-btn apple-btn"
        >
          {loading ? "Signing in..." : "Sign in with Apple"}
        </button>
      </div>
    </div>
  );
}

export default Login;
